const config = {
    basename: '',
    defaultPath: '/dashboard/lecturas',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12
};

export default config;
